exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__dropdown-card___3_YTb{display:flex;margin-bottom:10rem;min-height:3rem;background-color:transparent}.styles__dropdown-card___3_YTb .styles__button___2tWbz{display:flex;border-style:none;width:100%;transition:.4s}.styles__dropdown-card___3_YTb .styles__button___2tWbz:hover{transform:scale(1.1);border-radius:50px}", ""]);

// exports
exports.locals = {
	"dropdown-card": "styles__dropdown-card___3_YTb",
	"button": "styles__button___2tWbz"
};